import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { formatPhoneBr } from '../../models/whatsappNumber';

interface Props {
  open: boolean;
  phone: string;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmação de dígitos.
 *
 * O cadastro não tem pareamento por código: um dígito errado manda dado da rede
 * para o celular de um estranho. Esta é a barreira no ponto exato onde o erro
 * acontece — mostrar o número grande, separado, antes de gravar.
 */
const PhoneConfirmDialog = ({ open, phone, onCancel, onConfirm }: Props) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Confira o número</DialogTitle>
    <DialogContent>
      <Typography
        component="p"
        sx={{
          fontFamily: 'monospace',
          fontSize: '1.9rem',
          fontWeight: 600,
          letterSpacing: '0.04em',
          textAlign: 'center',
          my: 3,
        }}
      >
        {formatPhoneBr(phone) || phone}
      </Typography>
      <DialogContentText>
        Quem atender neste número vai receber informações da sua rede.
        Confira dígito por dígito antes de continuar.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Corrigir</Button>
      <Button variant="contained" onClick={onConfirm} autoFocus>
        Está correto
      </Button>
    </DialogActions>
  </Dialog>
);

export default PhoneConfirmDialog;
